module.exports = __webpack_public_path__ + "static/media/service.b2a380ce.png";